
import caffeBg from '../images/Nub/Caffe/CaffeBg.jpg'

import L1936C from '../images/LaGarela/1936/L1936C.png'
import boxBG from '../images/LaGarela/1936/boxBG.jpg'

import Aneomi from '../images/LaGarela/Aneomi/Aneomi.png'
import AneomiBg from '../images/LaGarela/Aneomi/AneomiBg.jpg'

import connecti from '../images/LaGarela/CB/connecti.png'
import CBBG from '../images/LaGarela/CB/CBBG.jpg'



import hubano from '../images/LaGarela/Habano/habano.png'
import habanoBG from '../images/LaGarela/Habano/habanoBG.jpg'

import maduro from '../images/LaGarela/Maduro/maduro.png';
import maduroBg from '../images/LaGarela/Maduro/maduroBg.jpg'


// 1936
import box1 from '../images/LaGarela/1936/box-1.png'
import box1Open from '../images/LaGarela/1936/box-1Open.jpg'
import box1Closed from '../images/LaGarela/1936/box-1Closed.jpg'

import box2 from '../images/LaGarela/1936/box-2.png'
import box2Open from '../images/LaGarela/1936/box-2Open.jpg'
import box2Closed from '../images/LaGarela/1936/box-2CLosed.jpg'

import box3 from '../images/LaGarela/1936/box-3.png'
import box3Open from '../images/LaGarela/1936/box-3Open.jpg'
import box3Closed from '../images/LaGarela/1936/box-3Closed.jpg'

import box4 from '../images/LaGarela/1936/box-4.png'
import box4Open from '../images/LaGarela/1936/box-4Open.jpg'
import box4Closed from '../images/LaGarela/1936/box-4Closed.jpg'

import box5 from '../images/LaGarela/1936/box-5.png'
import box5Open from '../images/LaGarela/1936/box-5Open.jpg'
import box5Closed from '../images/LaGarela/1936/box-5Closed.jpg'

import box6 from '../images/LaGarela/1936/box-6.png'
import box6Open from '../images/LaGarela/1936/box-6Open.jpg'
import box6Closed from '../images/LaGarela/1936/box-6Closed.jpg'

//Aneomi
import Aneomi1 from '../images/LaGarela/Aneomi/Aneomi-1.png'
import Aneomi1Open from '../images/LaGarela/Aneomi/AneomiOpen1.jpg'
import Aneomi1Closed from '../images/LaGarela/Aneomi/AneomiClosed1.jpg'

import Aneomi2 from '../images/LaGarela/Aneomi/Aneomi-2.png'
import Aneomi2Open from '../images/LaGarela/Aneomi/AneomiOpen2.jpg'
import Aneomi2Closed from '../images/LaGarela/Aneomi/AneomiClosed2.jpg'

import Aneomi3 from '../images/LaGarela/Aneomi/Aneomi-3.png'
import Aneomi3Open from '../images/LaGarela/Aneomi/AneomiOpen3.jpg'
import Aneomi3Closed from '../images/LaGarela/Aneomi/AneomiClosed3.jpg'

import Aneomi4 from '../images/LaGarela/Aneomi/Aneomi-4.png'
import Aneomi4Open from '../images/LaGarela/Aneomi/AneomiOpen4.jpg'
import Aneomi4Closed from '../images/LaGarela/Aneomi/AneomiClosed4.jpg'

import Aneomi5 from '../images/LaGarela/Aneomi/Aneomi-5.png'
import Aneomi5Open from '../images/LaGarela/Aneomi/AneomiOpen5.jpg'
import Aneomi5Closed from '../images/LaGarela/Aneomi/AneomiClosed5.jpg'


//Connecticut 
import Connecticut1 from '../images/LaGarela/CB/Connecticut1.png'
import Connecticut1Open from '../images/LaGarela/CB/Connecticut1Open.jpg'
import Connecticut1Closed from '../images/LaGarela/CB/Connecticut1Closed.jpg'

import Connecticut2 from '../images/LaGarela/CB/Connecticut2.png'
import Connecticut2Open from '../images/LaGarela/CB/Connecticut2Open.jpg'
import Connecticut2Closed from '../images/LaGarela/CB/Connecticut2Closed.jpg'

import Connecticut3 from '../images/LaGarela/CB/Connecticut3.png'
import Connecticut3Open from '../images/LaGarela/CB/Connecticut3Open.jpg'
import Connecticut3Closed from '../images/LaGarela/CB/Connecticut3Closed.jpg'

import Connecticut4 from '../images/LaGarela/CB/Connecticut4.png'
import Connecticut4Open from '../images/LaGarela/CB/Connecticut4Open.jpg'
import Connecticut4Closed from '../images/LaGarela/CB/Connecticut4Closed.jpg'

import Connecticut5 from '../images/LaGarela/CB/Connecticut5.png'
import Connecticut5Open from '../images/LaGarela/CB/Connecticut5Open.jpg'
import Connecticut5Closed from '../images/LaGarela/CB/Connecticut5Closed.jpg'

import Connecticut6 from '../images/LaGarela/CB/Connecticut6.png'
import Connecticut6Open from '../images/LaGarela/CB/Connecticut6Open.jpg'
import Connecticut6Closed from '../images/LaGarela/CB/Connecticut6Closed.jpg'



//Hubano
import habano1 from '../images/LaGarela/Habano/habano1.png'
import habano1Open from '../images/LaGarela/Habano/habano-1Open.jpg'
import habano1Closed from '../images/LaGarela/Habano/habano-1Closed.jpg'

import habano2 from '../images/LaGarela/Habano/habano2.png'
import habano2Open from '../images/LaGarela/Habano/habano-2Open.jpg'
import habano2Closed from '../images/LaGarela/Habano/habano-2Closed.jpg'

import habano3 from '../images/LaGarela/Habano/habano3.png'
import habano3Open from '../images/LaGarela/Habano/habano-3Open.jpg'
import habano3Closed from '../images/LaGarela/Habano/habano-3Closed.jpg'

import habano4 from '../images/LaGarela/Habano/habano4.png'
import habano4Open from '../images/LaGarela/Habano/habano-4Open.jpg'
import habano4Closed from '../images/LaGarela/Habano/habano-4Closed.jpg'

import habano5 from '../images/LaGarela/Habano/habano5.png'
import habano5Open from '../images/LaGarela/Habano/habano-5Open.jpg'
import habano5Closed from '../images/LaGarela/Habano/habano-5Closed.jpg'

import habano6 from '../images/LaGarela/Habano/habano6.png'
import habano6Open from '../images/LaGarela/Habano/habano-6Open.jpg'
import habano6Closed from '../images/LaGarela/Habano/habano-6Closed.jpg'

// Maduro
import maduro1 from '../images/LaGarela/Maduro/maduro1.png';
import maduro1Open from '../images/LaGarela/Maduro/maduro-1Open.jpg';
import maduro1Closed from '../images/LaGarela/Maduro/maduro-1Closed.jpg';

import maduro2 from '../images/LaGarela/Maduro/maduro2.png';
import maduro2Open from '../images/LaGarela/Maduro/maduro-2Open.jpg';
import maduro2Closed from '../images/LaGarela/Maduro/maduro-2Closed.jpg';

import maduro3 from '../images/LaGarela/Maduro/maduro3.png';
import maduro3Open from '../images/LaGarela/Maduro/maduro-3Open.jpg';
import maduro3Closed from '../images/LaGarela/Maduro/maduro-3Closed.jpg';

import maduro4 from '../images/LaGarela/Maduro/maduro4.png';
import maduro4Open from '../images/LaGarela/Maduro/maduro-4Open.jpg';
import maduro4Closed from '../images/LaGarela/Maduro/maduro-4Closed.jpg';

import maduro5 from '../images/LaGarela/Maduro/maduro5.png';
import maduro5Open from '../images/LaGarela/Maduro/maduro-5Open.jpg';
import maduro5Closed from '../images/LaGarela/Maduro/maduro-5Closed.jpg';


export const LaGarelaData = [
    {
        id: 1,
        title: 'La Galera 1936 Box Pressed',
        subTitle: 'Донесена от уважавания ветеран от индустрията Jochy Blanco, La Galera 1936 е средно до пълна кутия пресована доминиканска пура с впечатляваща тъмнокафява еквадорска обвивка Habano, обграждаща доминиканско свързващо вещество Criollo и доминикански пълнители Piloto Cubano и Criollo.',
        paragraphOne: `Съдържайки земни нотки на кожа, кафе и черен пипер, тази сложна смес не е нищо друго освен необикновена. „La Galera“ означава „подвижната стая“ на испански.`,
        imgUrl: L1936C,
        imagBg: boxBG,

        cigars: [
            {
                id: 1,
                title: 'La Galera 1936 Box Pressed Cabeza Caracol Churchill',
                subtitle: '7"1/4 * 50',
                img: box1,
                openBox: box1Open,
                closedBox: box1Closed,
            },
            {
                id: 2,
                title: 'La Galera 1936 Box Pressed Chaveta Robusto',
                subtitle: '5" * 50',
                img: box2,
                openBox: box2Open,
                closedBox: box2Closed,
            },
            {
                id: 3,
                title: 'La Galera 1936 Box Pressed Cortador Torpedo',
                subtitle: '6"1/8 * 52',
                img: box3,
                openBox: box3Open,
                closedBox: box3Closed,
            },
            {
                id: 4,
                title: 'La Galera 1936 Box Pressed El Lector Toro',
                subtitle: '6" * 54',
                img: box4,
                openBox: box4Open,
                closedBox: box4Closed,
            },
            {
                id: 5,
                title: 'La Galera 1936 Box Pressed Pegador Corona Gorda',
                subtitle: '5"1/2 * 46',
                img: box5,
                openBox: box5Open,
                closedBox: box5Closed,
            },
            {
                id: 6,
                title: 'La Galera 1936 Box Pressed Pilon Gordo',
                subtitle: '6"1/4 * 60',
                img: box6,
                openBox: box6Open,
                closedBox: box6Closed,
            },


        ]
    },
    {
        id: 2,
        title: 'La Galera Anemoi',
        subTitle: `
        La Galera Anemoi е ръчно изработена в фабриката Tabacalera Palma на Jose “Jochy” Blanco в Доминиканската република. Анемоите получават името си от гръцката дума за вятърни богове.`,
        paragraphOne: `
           Това е пурка със средно до пълно тяло, която се отличава с червеникава, мазна обвивка на САЩ от Кънектикът Broadleaf, покрита със свързващо вещество Corojo от Доминиканската република и пълнител, направен от Доминиканската република, Dominican Piloto 98 и Criollo 98 тютюни. La Galera Anemoi има вкусов профил, който се състои от кожа, кафе и ядки.        `,

        imgUrl: Aneomi,
        imagBg: AneomiBg,
        cigars: [
            {
                id: 1,
                title: 'La Galera Anemoi Anemoi',
                subtitle: '6"3/8 * 52',
                img: Aneomi1,
                openBox: Aneomi1Open,
                closedBox: Aneomi1Closed,
            },
            {
                id: 2,
                title: 'La Galera Anemoi Boreas',
                subtitle: '4"3/4 * 46',
                img: Aneomi2,
                openBox: Aneomi2Open,
                closedBox: Aneomi2Closed,
            },
            {
                id: 3,
                title: 'La Galera Anemoi Eurus ',
                subtitle: '5"1/2 * 48',
                img: Aneomi3,
                openBox: Aneomi3Open,
                closedBox: Aneomi3Closed,
            },
            {
                id: 4,
                title: 'La Galera Anemoi Notus',
                subtitle: '5" * 56',
                img: Aneomi4,
                openBox: Aneomi4Open,
                closedBox: Aneomi4Closed,
            },
            {
                id: 5,
                title: 'La Galera Anemoi Zephyrus',
                subtitle: '6" * 60',
                img: Aneomi5,
                openBox: Aneomi5Open,
                closedBox: Aneomi5Closed,
            }
        ]

    },
    {
        id: 3,
        title: 'La Galera Connecticut',
        subTitle: 'Представена ви от уважавания ветеран от индустрията Jochy Blanco, La Galera Connecticut е мека до средно тяло доминиканска пура с разкошна златистокафява еквадорска обвивка от Connecticut Shade, съчетана с първокласно доминиканско свързващо вещество и пълнител.',
        paragraphOne: `Съдържащ нотки на бадем, еспресо, пръст и сметана, тази гладка смес създава перфектна ежедневна пура, за ВСЯКО време от деня. „La Galera“ означава „подвижната стая“ на испански.`,
        imgUrl: connecti,
        imagBg: CBBG,
        cigars: [
            {
                id: 1,
                title: 'La Galera Connecticut Bonchero No.4',
                subtitle: '5"1/2 * 42',
                img: Connecticut1,
                openBox: Connecticut1Open,
                closedBox: Connecticut1Closed
            },
            {
                id: 2,
                title: 'La Galera Connecticut Cepo Pigtail Corona',
                subtitle: '5" * 38',
                img: Connecticut2,
                openBox: Connecticut2Open,
                closedBox: Connecticut2Closed,
            },
            {
                id: 3,
                title: 'La Galera Connecticut Chaveta Robusto',
                subtitle: '5"1/8 * 50',
                img: Connecticut3,
                openBox: Connecticut3Open,
                closedBox: Connecticut3Closed,
            },
            {
                id: 4,
                title: 'La Galera Connecticut Cortador Torpedo',
                subtitle: '6"1/8 * 52',
                img: Connecticut4,
                openBox: Connecticut4Open,
                closedBox: Connecticut4Closed,
            },
            {
                id: 5,
                title: 'La Galera Connecticut El Lector No.2 Tubo',
                subtitle: '5"7/8 * 52',
                img: Connecticut5,
                openBox: Connecticut5Open,
                closedBox: Connecticut5Closed,
            },
            {
                id: 6,
                title: 'La Galera Connecticut El Lector Toro',
                subtitle: '6" * 54',
                img: Connecticut6,
                openBox: Connecticut6Open,
                closedBox: Connecticut6Closed,
            },

        ]
    },
    {
        id: 4,
        title: 'La Galera Habano ',
        subTitle: 'Донесена от уважавания ветеран от индустрията Jochy Blanco, La Galera Habano е средно тяло доминиканска пура с красива медна еквадорска обвивка Habano на върха на доминиканско свързващо вещество Corojo и пищен микс от доминикански Piloto Cubano, Criollo 98 и Pelo de Oro пълнители.',
        paragraphOne: `
        Съдържайки кремообразни нотки на кедър, кафе и карамел, тази богата смес ще продължи да се развива и впечатлява до последното вдишване. „La Galera“ означава „подвижната стая“ на испански.
        `,
        imgUrl: hubano,
        imagBg: habanoBG,
        cigars: [
            {
                id: 1,
                title: 'La Galera Habano Bonchero No.4',
                subtitle: '5"1/2 * 42',
                img: habano1,
                openBox: habano1Open,
                closedBox: habano1Closed,
            },
            {
                id: 2,
                title: 'La Galera Habano Cabeza Caracol Churchill',
                subtitle: '7" * 47',
                img: habano2,
                openBox: habano2Open,
                closedBox: habano2Closed,
            },
            {
                id: 3,
                title: 'La Galera Habano Chaveta Robusto',
                subtitle: '5" * 50',
                img: habano3,
                openBox: habano3Open,
                closedBox: habano3Closed,
            },
            {
                id: 4,
                title: 'La Galera Habano Cortador Torpedo',
                subtitle: '6"1/4 * 52',
                img: habano4,
                openBox: habano4Open,
                closedBox: habano4Closed,
            },
            {
                id: 5,
                title: 'La Galera Habano El Lector No.2 Turbo',
                subtitle: '5"3/4 * 52',
                img: habano5,
                openBox: habano5Open,
                closedBox: habano5Closed,
            },
            {
                id: 6,
                title: 'La Galera Habano El Lector Toro',
                subtitle: '6" * 54 ',
                img: habano6,
                openBox: habano6Open,
                closedBox: habano6Closed,
            },
            
        ]
    },
    {
        id: 5,
        title: 'La Galera Maduro',
        subTitle: `Представен ви от уважавания ветеран от индустрията Jochy Blanco, La Galera Maduro е доминиканско пълноценно лакомство, включващо шоколадово кафяво мексиканско обвиване на San Andres, заедно с доминиканско свързващо вещество и пълнителна комбинация от доминикански Criollo '98 и Dominican Piloto Cubano`,
        paragraphOne: `
        Съдържащ силни нотки на какао, земя и кедър, тази грандиозна смес ще ви остави влюбени в своята смела сладост и гладко, богато покритие „La Galera“ означава „подвижната стая“ на испански.        `,
        imgUrl: maduro,
        imagBg: maduroBg,
        cigars: [
            {
                id: 1,
                title: 'La Galera Maduro Chaveta Robusto',
                subtitle: '5" * 50',
                img: maduro1,
                openBox: maduro1Open,
                closedBox: maduro1Closed,
            },
            {
                id: 2,
                title: 'La Galera Maduro Churchill',
                subtitle: '7"1/4 * 50',
                img: maduro2,
                openBox: maduro2Open,
                closedBox: maduro2Closed,
            },
            {
                id: 3,
                title: 'La Galera Maduro Cortador Torpedo',
                subtitle: '6"1/8 * 52',
                img: maduro3,
                openBox: maduro3Open,
                closedBox: maduro3Closed,
            },
            {
                id: 4,
                title: 'La Galera Maduro El Lector Toro',
                subtitle: '6" * 54 ',
                img: maduro4,
                openBox: maduro4Open,
                closedBox: maduro4Closed,
            },
            {
                id: 5,
                title: 'La Galera Maduro Pegador Corona Gorda',
                subtitle: '6" * 46',
                img: maduro5,
                openBox: maduro5Open,
                closedBox: maduro5Closed,
            },
            
        ]
    },
]